import pdfMake, { userMark, setMyConfig, makeTableContent } from '../utils/pdf';
import {
  getColumnsPerService,
  PRINT_COLUMNS,
} from '../modules/biblia/helpers/getColumnsPerService';

function pdfBibliaRegistros(pContent) {
  const idServicio = pContent.biblia.idServicio;

  let columnsPerService = getColumnsPerService(idServicio);
  columnsPerService = columnsPerService.filter(
    (item) => !(item == 'estado' || item == 'recomendacionesGuia')
  );

  const columns = [];

  columnsPerService.forEach((column) => {
    columns.push(PRINT_COLUMNS[column]);
  });

  const table = makeTableContent([...pContent.registros], columns);

  const columnsRecomendaciones = [
    {
      key: 'codigo',
      label: 'Código',
      width: 28,
    },
    {
      key: 'recomendacionesGuia',
      label: '',
      width: '*',
    },
  ];

  const partRecomendaciones = pContent.resumen.recomendaciones.length
    ? [
        {
          text: 'Recomendaciones',
          style: 'header',
        },
        makeTableContent([...pContent.resumen.recomendaciones], columnsRecomendaciones),
        {
          text: '',
          margin: [0, 0, 0, 5],
        },
      ]
    : [];

  pdfMake
    .createPdf({
      info: {
        title: `Reporte de Registros de Biblia`,
      },
      content: [
        {
          text: 'Reporte de Registros de Biblia',
          style: 'header',
        },
        {
          columns: [
            {
              text: `Servicio: ${pContent.resumen.servicio || ''}`,
              width: 'auto',
            },
            {
              text: `Fecha: ${pContent.resumen.fecha || ''}`,
              width: 'auto',
            },
          ],
          margin: [0, 0, 0, 2.5],
        },
        {
          text: 'Resumen',
          style: 'header',
        },
        {
          columns: [
            {
              text: `Vehículo(s): ${pContent.resumen.vehiculos || ''}`,
              width: 'auto',
            },
            {
              text: `Guía(s): ${pContent.resumen.guias || ''}`,
              width: 'auto',
            },
            {
              text: `Asistente(s): ${pContent.resumen.asistentes || ''}`,
              width: 'auto',
            },
          ],
          margin: [0, 0, 0, 5],
        },
        {
          text: '',
          margin: [0, 0, 0, 5],
        },
        table,
        ...partRecomendaciones,
        ...userMark(pContent.userMark, pContent.dateMark),
      ],
      ...setMyConfig(),
    })
    .print();
}

export default pdfBibliaRegistros;
